import { SocialShare } from "@quintype/components";
import React from "react";
import { object } from "prop-types";
import useStorage from "../../../hook/useStorage";
import StoryCard from "../../story-templates/story-card";
import SocialShareBottom from "../../story-templates/social-share";
import { useState, useEffect } from "react";
import TimeStamp from "../time-stamp";
import KeyHighlights from "../../story-templates/live-blog/key-highlights";
import CardShareTemplate from "../../story-templates/live-blog/card-share";
import "./story-component-live-blog.m.css"
const Subheadline = ({ subtitle }) => {
  return <p styleName="subheadline">{subtitle}</p>;
};

const StoryComponentLiveBlog = ({ story,showAds=false}) => {
  const allTagId = useStorage();
  const allTagIds = allTagId[3];

  const [currentStory, setCurrentStory] = useState(story);
  const [cardsCount, setCardsCount] = useState(story.cards.length);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const cardUniqueId = queryParams.get('cardId');
    const cardId = cardUniqueId;
    if (cardId) {
      setTimeout(function () {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
      }, 300);
    }

    setCurrentStory(story);
    setCardsCount(story.cards.length);

    const storyUpdateId = setInterval(updateStory, 5000);

    return () => {
      clearInterval(storyUpdateId);
    };
  }, []);

  const updateStory = async () => {
    const response = await window.fetch(`/api/v1/stories/${story.id}`);
    const jsonResponse = await response.json();
    setCardsCount(jsonResponse.story.cards.length);
    setCurrentStory(jsonResponse.story);
  };

  const liveblogData = (data) => {
    return (
      <>
        {data.subheadline && <Subheadline subtitle={data.subheadline} />}
        {data &&
          data.cards.map((card, index) => {

            return (
              <div key={card.id} id={card.id}>
                <div styleName="story-cards" key={index}>
                  <div styleName="show-time">
                    <div styleName="published-time">
                      <span styleName="clock-icon">
                        <img src="/assetify/clock.svg" alt="clock" width="14" />
                      </span>
                      <TimeStamp prefix="" timeStamp={card["card-added-at"]} />
                    </div>
                    <SocialShare
                      template={CardShareTemplate}
                      title={card.metadata["social-share"].title || data.headline}
                      url={encodeURIComponent(data && data.slug + "?cardId=" + card.id)}
                    />
                  </div>

                  <StoryCard key={card.id} card={card} story={data} />
                </div>
              </div>
            );
          })}
      </>
    );
  };

return (
  <div styleName="story-body" className="story-body">
    <div>
      <article>
        <div itemProp="articleBody">
          <div>
            {!cardsCount ? <KeyHighlights story={story} /> : <KeyHighlights story={currentStory} />}
            {!cardsCount ? liveblogData(story) : liveblogData(currentStory)}
            {<span className="article_end" styleName="article_end_style"></span>}
            <SocialShareBottom story={story} />
          </div>

        </div>
      </article>
      <div className="voice-no-read asiavirhe-wrapper" styleName="asiavirhe-wrapper">
        <a styleName="asiavirhe-link" href={`mailto:verkko@ilkkapohjalainen.fi?subject=Asiavirheilmoitus artikkelista ${story.headline}`} >Ilmoita asiavirheestä</a>
      </div>
    </div>
  </div>
  )
              }
StoryComponentLiveBlog.propTypes = {
  story: object
};
export default StoryComponentLiveBlog;
